(function () {
    "use strict";

    angular.module("app").component("inspectionResultView", {
        templateUrl: "@/installation/inspection-result-view.html",
        bindings: {
            inspectionResult: "="
        },
    });
})();